import { createRoute } from '@/utils/routing'

export const REFERRAL_LIST_ROUTE = 'referrals'

export function createReferralListRoute (options = {}) {
  return createRoute(REFERRAL_LIST_ROUTE, options)
}
